import { api } from '@/core/api/';

const header = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};

const URL = 'api/provider';

export const getStatesOptions = () => api.get(`${URL}/stateslocationsoptions`);

export const getLocations = (academicYearId, companyId) =>
  api.get(`${URL}/locations/${academicYearId}/${companyId}`);

export const saveLocation = (payload) =>
  api.post(`${URL}/submitlocation`, payload, header);

export const deleteLocation = (locationId) =>
  api.delete(`${URL}/deletelocation/${locationId}/`);
